var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_5931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_5931)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#C51918"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2757_5931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2757_5931)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V13.4167H11.5V0H0Z",
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56282 7.44827L1.80091 8.06156L1.97469 6.86479L1.34021 5.96913L2.19934 5.9207L2.56282 4.80322L2.9263 5.9207H3.78396L3.15094 6.86479L3.34152 8.06156L2.56282 7.44827Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31282 7.44827L7.55091 8.06156L7.72469 6.86479L7.09021 5.96913L7.94934 5.9207L8.31282 4.80322L8.6763 5.9207H9.53396L8.90094 6.86479L9.09151 8.06156L8.31282 7.44827Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3659 3.96553L4.64881 4.54274L4.81237 3.41638L4.21521 2.5734L5.0238 2.52782L5.3659 1.47607L5.708 2.52782H6.51521L5.91942 3.41638L6.09879 4.54274L5.3659 3.96553Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14261 8.07398L5.69443 8.43473L5.79666 7.73075L5.42343 7.2039L5.9288 7.17541L6.14261 6.51807L6.35642 7.17541H6.86093L6.48857 7.73075L6.60067 8.43473L6.14261 8.07398Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32505 12.2938L4.24941 13.1596L4.49476 11.47L3.59901 10.2056L4.8119 10.1372L5.32505 8.55957L5.83819 10.1372H7.04901L6.15534 11.47L6.42439 13.1596L5.32505 12.2938Z",
    fill: "#FEFFFF"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2757_5931)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_5931",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWst);
export default __webpack_public_path__ + "static/media/WST.c1c692831d620455c44e7b3d68fae5f4.svg";
export { ForwardRef as ReactComponent };